import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {yup} from "./index";


export const useIncidentSchema = (props) => {
    const pre2021 = props?.pre2021 ?? false;
    const {t} = useTranslation('validation');

    const number = yup.number().emptyToNull().typeError(t('validation:number'))
    const positiveNumber = number.min(0, t('validation:gte', {gte: 0}));
    const positiveInteger = number.integer(t('validation:integer')).min(0, t('validation:gte', {gte: 0}))

    return useMemo(
        () => (
            yup.object().shape({
                date: yup.date().required(t('validation:required')),
                timeRange: pre2021 ? yup.string().nullable() : yup.string().required(t('validation:required')),
                workgroupId: yup.number().required(t('validation:required')),
                regionId: yup.number().required(t('validation:required')),
                provinceId: yup.number().required(t('validation:required')),
                locationName: yup.string().nullable(),
                elevationRelease: positiveInteger,
                aspect: yup.string().required(t('validation:required')),
                geom: yup.object().shape({
                    coordinates: yup.array().of(
                        positiveNumber.required(t('validation:required'))
                    ),
                }),

                // Conditions
                snowHeightMin: positiveInteger,
                snowHeightMax: positiveInteger,
                slopeAngleRelease: positiveInteger,
                avalancheType: yup.string().required(t('validation:required')),
                avalancheSizeV1: yup.string().required(t('validation:required')),
                ww: yup.string().required(t('validation:required')),
                daysSinceLastSnowfall: positiveInteger,
                nearRidge:  pre2021 ? yup.string().nullable() : yup.string().required(t('validation:required')),
                dangerScaleBulletin: pre2021 ? yup.string().nullable() : yup.string().required(t('validation:required')),
                ...(pre2021 ? {dangerScalePre93: yup.string().required(t('validation:required'))} : {}),

                // Incident
                incidentCategoryV1: yup.string().required(t('validation:required')),
                numberOfPeopleInvolved: positiveInteger,
                numberOfPeopleCaught: positiveInteger,
                numberOfUninjured: positiveInteger,
                uninjuredCompletelyBuried: positiveInteger,
                uninjuredPartiallyBuried: positiveInteger,
                uninjuredShallowBuried: positiveInteger,
                uninjuredFoundWithBeacon: positiveInteger,
                uninjuredFoundWithUcv: positiveInteger,
                uninjuredFoundWithProbing: positiveInteger,
                uninjuredFoundWithHearingSight: positiveInteger,
                uninjuredSelfRescued: positiveInteger,

                numberOfInjured: positiveInteger,
                injuredCompletelyBuried: positiveInteger,
                injuredPartiallyBuried: positiveInteger,
                injuredShallowBuried: positiveInteger,
                injuredFoundWithBeacon: positiveInteger,
                injuredFoundWithUcv: positiveInteger,
                injuredFoundWithProbing: positiveInteger,
                injuredFoundWithHearingSight: positiveInteger,
                injuredSelfRescued: positiveInteger,

                numberOfDeaths: positiveInteger,
                deadMissing: positiveInteger,
                deadRecovered: positiveInteger,
                deadCompletelyBuried: positiveInteger,
                deadPartiallyBuried: positiveInteger,
                deadShallowBuried: positiveInteger,
                deadFoundWithBeacon: positiveInteger,
                deadFoundWithUcv: positiveInteger,
                deadFoundWithProbing: positiveInteger,
                deadFoundWithHearingSight: positiveInteger,
                deadBySuffocation: positiveInteger,
                deadByTrauma: positiveInteger,
                deadByOther: positiveInteger,

                rescueType: yup.string().required(t('validation:required')),
                alpineRescue: yup.string().required(t('validation:required')),

                burialTimePerson1: positiveInteger,
                burialTimePerson2: positiveInteger,
                burialTimePerson3: positiveInteger,
                burialDepthPerson1: positiveInteger,
                burialDepthPerson2: positiveInteger,
                burialDepthPerson3: positiveInteger,

                notes: yup.string().nullable(),
            }))
        ,
        [t]
    )
}